// stimulus/controllers/address_book-form_controller.js
import { Controller } from "@hotwired/stimulus";
import JustValidate from "just-validate";

export default class extends Controller {
    connect() {
        // Build validator
        this.validator = new JustValidate(this.element, {
            validateBeforeSubmitting: false, // we will submit ourselves
            lockForm: false,
            focusInvalidField: true,
            errorFieldCssClass: "is-invalid",
        });

        this.validator
            .addField("#contact_first_name", [
                { rule: "required", errorMessage: "First name is required" },
            ])
            .addField("#contact_last_name", [
                { rule: "required", errorMessage: "Last name is required" },
            ])
            .addField("#contact_email", [
                { rule: "required", errorMessage: "Email is required" },
                { rule: "email", errorMessage: "Please enter a valid email address" },
            ])
            .addField("#contact_phone_number", [
                { rule: "required", errorMessage: "Telephone is required" },
            ]);

        this.validator.onSuccess(async () => {
            const form = this.element;
            const fd = new FormData(form);
            const res = await fetch(form.action, {
                method: form.method || "POST",
                headers: {
                    "Accept": "text/vnd.turbo-stream.html",
                    "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content || ""
                },
                body: fd
            });
            if (!res.ok) return; // optionally toast
            Turbo.renderStreamMessage(await res.text());
        });
    }
}